export const BLOG_COVER_MODES = ['crop', 'full'] as const;
export type BlogCoverMode = (typeof BLOG_COVER_MODES)[number];

export const BLOG_COVER_FOCAL_POINTS = [
  'center', 'top', 'bottom', 'left', 'right',
  'top-left', 'top-right', 'bottom-left', 'bottom-right',
] as const;
export type BlogCoverFocalPoint = (typeof BLOG_COVER_FOCAL_POINTS)[number];

const positions: Record<BlogCoverFocalPoint, string> = {
  center: '50% 50%',
  top: '50% 0%',
  bottom: '50% 100%',
  left: '0% 50%',
  right: '100% 50%',
  'top-left': '0% 0%',
  'top-right': '100% 0%',
  'bottom-left': '0% 100%',
  'bottom-right': '100% 100%',
};

export function blogCoverMode(value: unknown): BlogCoverMode {
  return value === 'full' ? 'full' : 'crop';
}

export function blogCoverFocus(value: unknown): BlogCoverFocalPoint {
  return typeof value === 'string' && value in positions
    ? value as BlogCoverFocalPoint
    : 'center';
}

export function blogCoverPosition(value: unknown): string {
  return positions[blogCoverFocus(value)];
}
